import { Button, SimpleGrid, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  MdBusiness,
  MdPeople,
  MdEvent,
  MdEmail,
  MdCardMembership,
} from 'react-icons/md';

export default function QuickActionsCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  const actions = [
    {
      label: t('dashboard.go_to_businesses'),
      icon: MdBusiness,
      path: '/admin/businesses/overview',
    },
    {
      label: t('dashboard.go_to_users'),
      icon: MdPeople,
      path: '/admin/brilliant_users/overview',
    },
    {
      label: t('dashboard.go_to_events'),
      icon: MdEvent,
      path: '/admin/events/overview',
    },
    {
      label: t('dashboard.go_to_invites'),
      icon: MdEmail,
      path: '/admin/invites/overview',
    },
    {
      label: t('dashboard.go_to_plans'),
      icon: MdCardMembership,
      path: '/admin/subscription_plans/overview',
    },
  ];

  return (
    <Card p="20px" w="100%">
      <Text color={textColor} fontSize="lg" fontWeight="700" mb="16px">
        {t('dashboard.quick_actions')}
      </Text>
      <SimpleGrid columns={{ base: 2, md: 3, lg: 5 }} gap="12px">
        {actions.map((a) => (
          <Button
            key={a.path}
            variant="outline"
            colorScheme="brand"
            size="sm"
            leftIcon={<a.icon />}
            onClick={() => navigate(a.path)}
          >
            {a.label}
          </Button>
        ))}
      </SimpleGrid>
    </Card>
  );
}
